import { render, staticRenderFns } from "./headerBreadcrumbs.vue?vue&type=template&id=23bfd629&scoped=true"
import script from "./headerBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./headerBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./headerBreadcrumbs.vue?vue&type=style&index=0&id=23bfd629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfd629",
  null
  
)

export default component.exports